export default __webpack_public_path__ + "static/media/road_construction_equipment_rental.539cc97c.png";